var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLayer = function SvgLayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M947.648 460.544 1024 512 512 857.088 0 512l76.352-51.456L512 754.112l435.648-293.568zM59.52 631.04 512 928l452.48-296.96L1024 672l-512 352L0 672l59.52-40.96zM512 0l512 345.088-512 345.024L0 345.088 512 0z"
  })));
};
export default SvgLayer;